export default __webpack_public_path__ + "static/media/V302.09d91f26.jpg";